<template src="./template.html"></template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'StreamWidget',
    components: {
      NewsStream: () => import('@/components/modules/NewsStream'),
    },
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
      type: {
        type: String,
        default: () => null,
      },
    },
    computed: {
      ...mapState('auth', ['settings']),
    },
  }
</script>
